import React from 'react';
import { Button, MainLayout, Triptych } from '@app/components';
import { PromotionList, PromotionDeleteModal, PromotionCreate, PromotionUpdate } from '@app/features/Promotion';
import { useResourceScreenHelpers } from '@app/hooks';
import { promotionApi } from '@app/store';
import { IPromotion } from '@app/common';
import { SettingHeader } from '@app/features/SettingHeader';
import { CheckPermissions } from '@app/components/CheckPermissions';

export const PromotionScreen = () => {
  const [readOne, { isFetching }] = promotionApi.useLazyReadOnePromotionsQuery();
  const [deleteOne, { isLoading }] = promotionApi.useDeleteOnePromotionsMutation();

  const { triptych, modal, onDelete, onUpdate, mode, selectedItem, item: promotion } = useResourceScreenHelpers<IPromotion>();

  const openCard = (item: Partial<IPromotion>) => {
    onUpdate(readOne({
      filters: { _id: { $eq: item._id } },
      populate: [
        'tags',
        'connectors',
        'conditions',
        'actions',
      ]
    }), item)
  }

  return (
    <MainLayout
      header={(
        <SettingHeader>
          <CheckPermissions permissions={['dashboard::promotions.create']}>
            <Button
              onPress={() => triptych.open({ mode: 'CREATE' })}
              title='Ajouter une promotion' />
          </CheckPermissions>
        </SettingHeader>
      )}>

      <PromotionDeleteModal
        {...modal}
        onDelete={(promotion) => onDelete(deleteOne(promotion._id!))}
        isLoading={isLoading} />

      <Triptych
        list={(
          <PromotionList
            selectedRowItem={selectedItem}
            onRowPress={(item) => triptych.close({ data: item, mode: 'UPDATE' })}
            onUpdate={openCard}
            onDelete={modal.open} />
        )}
        form={(
          mode === 'CREATE'
            ? <PromotionCreate />
            : <PromotionUpdate
              promotion={promotion ?? selectedItem}
              toggle={(mode) => mode === 'UPDATE' ? openCard(selectedItem) : triptych.close()}
              isFetching={isFetching}
              onDelete={modal.open} />
        )} />
    </MainLayout>
  );
};

